export default {
    namespaced: true,
    state: {
        locale: 'ro',
        fallBackLanguage: 'en',
        defaultLocale: 'ro',
        languages: {
            'ro': 'Română',
            'en': 'English',
            'de': 'Deutsch',
            'hu': 'Magyar',
            'sr': 'Szerb',
            'ru': 'Pусский',
            'tr': 'Türk',
            'bg': 'български',
            'pl': 'Polski',
            'ua': 'Yкраї́нська',
        },
        hasLangInUrl: false
    },
    mutations: {
        setLocale: function(state, locale) {
            state.locale = locale;
        },

        setHasLangInUrl: function(state, status) {
            state.hasLangInUrl = status;
        }
    },
    actions: {
        setLocale({commit}, locale) {
            commit('setLocale', locale);
        },

        setHasLangInUrl({commit}, status) {
            commit('setHasLangInUrl', status);
        },
    },
    getters: {
        getLanguage: function(state) {
            return state.locale;
        },
        getLanguages: function(state) {
            return state.languages;
        },
        getDefaultLanguage: function(state) {
            return state.defaultLocale;
        },
        getFallBackLanguage: function(state) {
            return state.fallBackLanguage;
        },
        getHasLangInUrl: function(state) {
            return state.hasLangInUrl;
        }
    }
}
